import { getCookie } from './cookie';

const isValidVersion = (version) => {
  const apiVersions = devsite?.reference?.apiVersions;
  return Array.isArray(apiVersions) && apiVersions.includes(version);
};

/*  
   Version value from cookie is not validated as it is mostly used for non api 
   reference pages which don't have access to apiVersions.
*/
export const withVersion = (url) => {
  const lastPath = window.location.pathname.split('/').pop();
  const version = isValidVersion(lastPath) ? lastPath : getCookie('version');

  if (version && devsite?.user?.active_staff) {
    if (url === '/api/reference') {
      return url + `/v/${version}`;
    }
    return url + `/${version}`;
  }

  return url;
};
